module.exports = __webpack_public_path__ + "07e00a45c3fbfb7597451c7c0a5d9b64.pdf";